module.exports = __webpack_public_path__ + "media/images/collapse-a4c1dbedf3f7af0c0e50b34e86b07137.png";